import React, { useEffect, useState } from 'react'
import "./ProductsListContainer.css"
import { Col, Container, Row } from 'react-bootstrap'
import ProductCard from '../ProductCard/ProductCard'
import { useParams } from 'react-router-dom';
import { useSelector } from "react-redux";
import axios from 'axios';
import ProductItem from '../ProductItem/ProductItem';

function ProductsListContainer({stock,size,color}) {
  const { id } = useParams(); // Extracts the "id" from the URL
  
  const ids = id!==undefined&&id.split("/").pop(); // Split by '/' and get the last part

  const products = useSelector((state) => state);

const [productsArray, setProductsArray] = useState([])
  useEffect(() => {
const getData=async()=>{
if(id){
  await axios
  .get(`https://nanosoft.technology/outlaw/api/products?category_id=${ids}`)
  .then(async (res) => {

    setProductsArray(res.data.data);

  })
  .catch((error) => {

    console.log(error.response.data);


  });
}else{
  await axios
  .get(`https://nanosoft.technology/outlaw/api/products?color=${color&&color}&size=${size&&size}&inStock=${stock&&stock}`)
  .then(async (res) => {
    setProductsArray(res.data.data);


  })
  .catch((error) => {

    console.log(error.response.data);


  });
}







// if(id){
//   await axios
//   .get(`https://nanosoft.technology/outlaw/api/categories/${ids}`)
//   .then(async (res) => {
//     setProductsArray(res.data.products);

//   })
//   .catch((error) => {

//     console.log(error.response.data);


//   });
// }else{
//   await axios
//   .get(`https://nanosoft.technology/outlaw/api/products?color=${color&&color}&size=${size&&size}&inStock=${stock&&stock}`)
//   .then(async (res) => {
//     setProductsArray(res.data);

//   })
//   .catch((error) => {

//     console.log(error.response.data);


//   });
// }

}
getData()
  }, [color,size,stock])
  return (
    <div>
        <Container>
            <div className='d-flex justify-content-between'>

            </div>
            <Row>
              {productsArray?.length!==0?productsArray?.map((item,index)=>{
                
                return(
                  <Col md={3} key={index}className='pe-0 ps-2'>
                        <ProductItem
product={item}
/>         
                        </Col>
                )
              })
       
            :
            <div className='d-flex justify-content-center align-items-center h-100 text-danger fs-5 fw-bold'>No Product Found</div>

            }
              {/* {id?
            <>id</>  
            :
            products.productsRducer.productsArray.length!==0?
            products.productsRducer.productsArray.map((item,index)=>{
              console.log(item);
              
              return(
                <Col md={3} key={index}>
                <ProductCard  
                item={item}
                img={'https://cdn.tozlu.com/img/640/85/kadin-dik-yaka-fermuarli-polar-sweatshirt-1b208-11e411.webp'}/>

               </Col>
            )})


            :
            <div className='d-flex justify-content-center align-items-center h-100 text-danger fs-5 fw-bold'>No Product Found</div>
            
            } */}
              {/* {
              !id?products.productsRducer.productsArray&&products.productsRducer.productsArray.map((item,index)=>{
                console.log(item);
                
                return(
                  <Col md={3} key={index}>
                  <ProductCard  
                  item={item}
                  img={'https://cdn.tozlu.com/img/640/85/kadin-dik-yaka-fermuarli-polar-sweatshirt-1b208-11e411.webp'}/>
 
                 </Col>
                )


              })
              :
              
              
              } */}
           
    
            </Row>
        </Container>
    </div>
  )
}

export default ProductsListContainer